import React from 'react';

export const CancelIconWithForbidden = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M9.9974 1.66663C5.3974 1.66663 1.66406 5.39996 1.66406 9.99996C1.66406 14.6 5.3974 18.3333 9.9974 18.3333C14.5974 18.3333 18.3307 14.6 18.3307 9.99996C18.3307 5.39996 14.5974 1.66663 9.9974 1.66663ZM3.33073 9.99996C3.33073 6.31663 6.31406 3.33329 9.9974 3.33329C11.5391 3.33329 12.9557 3.85829 14.0807 4.74163L4.73906 14.0833C3.82387 12.9192 3.32772 11.4807 3.33073 9.99996ZM9.9974 16.6666C8.45573 16.6666 7.03906 16.1416 5.91406 15.2583L15.2557 5.91663C16.1709 7.08068 16.6671 8.51922 16.6641 9.99996C16.6641 13.6833 13.6807 16.6666 9.9974 16.6666Z" fill="#0075AA" />
    </svg>
  );
};
